<template>
<div class="container-login">
  <div class="wrap-login">
    <form class="login-form" @submit.prevent="login">
      <div class="wrap-input">
        <input data-username v-model="username" :placeholder="$t('login.input.user')" required autocomplete="off" class="input" type="text">
        <span class="focus-input"></span>
        <span class="symbol-input">
          <i class="fa fa-user" aria-hidden="true"></i>
        </span>
      </div>

      <div class="wrap-input">
        <input data-password autocomplete="off" v-model="password" :placeholder="$t('login.input.password')" class="input" required type="password">
        <span class="focus-input"></span>
        <span class="symbol-input">
          <i class="fa fa-lock" aria-hidden="true"></i>
        </span>
      </div>
      <div class="container-login-form-btn">
        <button class="login-form-btn">
          {{$t('login.button')}}
        </button>
      </div>

    </form>
  </div>
</div>
</template>
<script>
import i18n from './i18n'
import { VIEWS } from '@/router/base'
import { APP_REDIRECT_ON_LOGIN } from '@/enviroment/app'
import { LOGIN_REDIRECTION_QUERY, LOGIN_REDIRECTION_NAME } from '@/views/Login'
export default {
  name: 'loginBase',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
    },
    login () {
      this.$servicesPLK.connection.getConnectionsByType(this.$servicesPLK.connection.TYPE.PLAKA).then(async (connections) => {
        await Promise.all(connections.map(conn => conn.loginInApp(this.username, this.password)))
        await this.$router.push({
          name: this.$route.query[LOGIN_REDIRECTION_NAME] || VIEWS.VIEWER.name,
          params: { id: this.$route.query[LOGIN_REDIRECTION_QUERY] || APP_REDIRECT_ON_LOGIN }
        })
      })
    }
  }
}
</script>

<style scoped>
.container-login {
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: #ff5733;
  background: -webkit-linear-gradient(-135deg, #ff5733, #ffc302);
  background: -o-linear-gradient(-135deg, #ff5733, #ffc302);
  background: -moz-linear-gradient(-135deg, #ff5733, #ffc302);
  background: linear-gradient(-135deg, #ff5733, #ffc302);
}

.wrap-login {
  width: 960px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;

  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 5%;
}

.login-form {
  width: 100%;
  margin-bottom: 0px;
}

/*---------------------------------------------*/
.wrap-input {
  position: relative;
  width: 100%;
  z-index: 1;
  margin-bottom: 10px;
}

.input {
  line-height: 1.5;
  color: #666666;

  display: block;
  width: 100%;
  background: #e6e6e6;
  height: 50px;
  border-radius: 25px;
  padding: 0 30px 0 68px;
}

/*------------------------------------------------------------------
[ Focus ]*/
.focus-input {
  display: block;
  position: absolute;
  border-radius: 25px;
  bottom: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 0px 0px;
  color: #571844;
}

.input:focus + .focus-input {
  -webkit-animation: anim-shadow 0.5s ease-in-out forwards;
  animation: anim-shadow 0.5s ease-in-out forwards;
}

.symbol-input {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  position: absolute;
  border-radius: 25px;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-left: 35px;
  pointer-events: none;
  color: #666666;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.input:focus {
  border-color: #571844;
}

.input:focus + .focus-input + .symbol-input {
  color: #571844;
  padding-left: 28px;
}

/*------------------------------------------------------------------
[ Button ]*/
.container-login-form-btn {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 20px;
}

.login-form-btn {
  line-height: 1.5;
  color: #fff;
  text-transform: uppercase;

  width: 100%;
  height: 50px;
  border-radius: 25px;
  background: #571844;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 25px;
  margin-bottom: 0px;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.login-form-btn:hover {
  background: #900c3e;
}
</style>
